import { render } from "./Tupoksi.vue?vue&type=template&id=8233e296"
import script from "./Tupoksi.vue?vue&type=script&lang=js"
export * from "./Tupoksi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__